import { CommonKeys } from "../../../common/enums";
import { STAMM_DYNFIELD_TYPE } from "../../../common/formular-group-types";
import { STAMM_ANLAGE_TYPE } from "../../interfaces/stammelements/StammElementAnlage";
import { STAMM_BELEG_TYPE } from "../../interfaces/stammelements/StammElementBeleg";
import { STAMM_META_TYPE } from "../../interfaces/stammelements/StammElementMeta";
import { STAMM_TASK_TYPE } from "../../interfaces/stammelements/StammElementTask";
import { STAMM_VERTRAG_TYPE } from "../../interfaces/stammelements/StammElementVertrag";

const STAMM_TYPES = [
    STAMM_META_TYPE,
    STAMM_DYNFIELD_TYPE,
    STAMM_ANLAGE_TYPE,
    STAMM_VERTRAG_TYPE,
    STAMM_BELEG_TYPE,
    STAMM_TASK_TYPE
];

export const FormularGroupStammStammElementBaseSchema = {
    $id: "FormularGroupStammStammElementBaseSchema",
    title: "StammElement Schema for StammElemente Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { enum: STAMM_TYPES },
        [CommonKeys.ID]: { type: "string", nullable: true },
        [CommonKeys.Label]: { type: "string" },
        [CommonKeys.Value]: { type: "string", nullable: true },
        [CommonKeys.IsReadonly]: { type: "boolean", nullable: true },
    },
    required: [CommonKeys.Type, CommonKeys.ID, CommonKeys.Label, CommonKeys.Value, CommonKeys.IsReadonly]
};